import { Component, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { ConstantsService, PARAM_LABEL_BENEFICIAIRE } from 'src/app/core/services/constant/constants.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { DataStorageService } from 'src/app/core/services/dataStorage/data-storage.service';

@Component({
	selector: 'app-beneficiaire-modal-ajout-form',
	templateUrl: './beneficiaire-modal-ajout-form.component.html',
	styleUrls: ['./beneficiaire-modal-ajout-form.component.scss']
})
export class BeneficiaireModalAjoutFormComponent implements OnInit {
	LABEL_BENEFICIAIRE: string;

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	isPreferencesActive = false;

	beneficiaire = new Beneficiaire();

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = this.fb.group({
		firstName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		lastName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		address: new FormControl(new Address().label, [
			// Validators.maxLength(60)
		]),
		
		birthDate: new FormControl<Date>(null),
		telephone: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
		email: new FormControl('', Validators.email),
		genre: new FormControl(''),
		handicapPrincipal: new FormControl(''),
		modeCommunication: new FormControl(''),
		degreSurdite: new FormControl(''),
		tauxReconnaissance: new FormControl(),
		niveauEtude: new FormControl(),
		niveauQualification: new FormControl(),
		statutProfessionnel: new FormControl(),
		//eligibiliteBeneficiaire: new FormControl(),
		//situationFamiliale: new FormControl(),
		origineHandicap: new FormControl(''),
		doleances: new FormControl(''),
		rapportHandicap: new FormControl(''),
		environnementSocial: new FormControl(''),
		diplomes: this.fb.array([this.fb.group({
			etablissement: '',
			annee: '',
			amenagement: '',
			niveauEtude: ''
		})]),
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	@Output() updateListing = new EventEmitter();


	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private toastService: ToastService,
		private fb: FormBuilder,
		private appConstants: ConstantsService,
		private dataStorageService: DataStorageService
	) {
		// form = this.fb.group({
		// 	diplomes: this.fb.array(items)
		// });
	}

	ngOnInit(): void {
		this.LABEL_BENEFICIAIRE =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.isPreferencesActive =
			this.facade.dataStorageService.isPreferencesBeneficiaireActive();
	
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;

		const oldBeneficiaire = this.beneficiaire;
		this.facade.beneficiaireService
			.addBeneficiaire(this.beneficiaire)
			.subscribe({
				next: (addedBeneficiaireId: number) => {
					this.beneficiaire.id = addedBeneficiaireId;
					this.isValidateButtonClicked.value = false;
					this.bsModalRef.hide();
					this.updateListing.emit(this.beneficiaire);
					// oldBeneficiaire.id = null;
					// this.facade.authenticationService.authenticateIsy(this.appConstants.loginIsy, this.appConstants.passwordIsy).subscribe({
					// 	next: (val) => {
					// 		this.dataStorageService.setTokenIsy(val.token);
					// 		console.log(val);
					// 		this.facade.beneficiaireService.addBeneficiaireIsy(oldBeneficiaire).subscribe({
					// 			next : (val) => {
					// 				console.log(val);
					// 				this.isValidateButtonClicked.value = false;
					// 				this.bsModalRef.hide();
					// 				this.updateListing.emit(this.beneficiaire);
					// 			}
					// 		});
					// 	}
							
					// })
				},
				error: (err: ErrorResponse) => {
					console.log(err)
					this.isValidateButtonClicked.value = false;
					this.toastService.createHttpErrorToast(
						err.error.message,
						err.status
					);
				}
			});
	}
}
